import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
        // Relatório do módulo de Agendamento. Mantém as permissões que ele já
        // tinha dentro do módulo (agente enxerga) em vez de herdar o
        // `report_manage` dos demais, para não tirar acesso de quem já via.
        {
          path: 'appointments',
          name: 'appointments_reports',
          meta: {
            permissions: ['administrator', 'agent'],
          },
          component: () => import('../../appointments/AppointmentsReports.vue'),
        },
        // O dashboard do Pipeline mora junto com os outros relatórios, e não mais
        // dentro do módulo Pipeline. Mantém as permissões que ele já tinha
        // (agente com pipeline_view enxerga) em vez de herdar o `report_manage`
        // dos demais.
        {
          path: 'pipeline',
          name: 'pipeline_reports',
          meta: {
            permissions: [
              'administrator',
              'agent',
              'pipeline_manage',
              'pipeline_view',
            ],
          },
          component: () =>
            import('../../pipeline/UnifiedPipelineDashboard.vue'),
        },
        // Relatório da cross feature Oportunidades (flag `pipeline_opportunities`):
        // vendas registradas quando um card do Pipeline é marcado como ganho.
        // A flag no `meta` é o que faz a sidebar esconder o item para quem não
        // contratou — ver `provider.js`, que resolve visibilidade pelo meta da rota.
        {
          path: 'opportunities',
          name: 'opportunities_reports',
          meta: {
            featureFlag: FEATURE_FLAGS.PIPELINE_OPPORTUNITIES,
            permissions: [
              'administrator',
              'agent',
              'pipeline_manage',
              'pipeline_view',
            ],
          },
          component: () =>
            import('../../pipeline/opportunities/OpportunitiesReport.vue'),
        },
        {
          path: 'lead-score',
          name: 'lead_score_reports',
          meta: {
            featureFlag: FEATURE_FLAGS.LEAD_SCORE,
            permissions: ['administrator', 'owner'],
          },
          component: () => import('../../reports/lead-score/Index.vue'),
        },
      ],
    },
  ],
};
